import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { Card, Grid, Typography } from '@material-ui/core';

// project card
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import MuiTypography from '@material-ui/core/Typography';
import convertStatus from "../../utils/convertStatus";
import {FormattedMessage} from "react-intl";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons/index'
import { fab } from '@fortawesome/free-brands-svg-icons/index'
import {library} from "@fortawesome/fontawesome-svg-core";

import { withStyles } from '@material-ui/core/styles';
import { Tooltip as MuiTooltip} from '@material-ui/core';
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import Button from "@material-ui/core/Button";

//-----------------------|| USER DETAILS CARD ||-----------------------//

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#1a223f',
        color: '#d7dcec',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9'
    }
}))(MuiTooltip);

const OrderOne = ({order, rowsHorizontal, itemCount, itemsLength}) => {
    library.add(fas, fab);
    const status = convertStatus(order.status);

    return (
      <Grid item xs={12} md={(rowsHorizontal && rowsHorizontal === 1) ? 12 : 6}>
          <Grid container spacing={1}>
              <Grid item xs={12}>
                  <Typography variant="caption">
                      <FormattedMessage id="orders-status" />
                  </Typography>
                  <Typography variant="h6">
                      {status?.title ?? ''}
                  </Typography>
              </Grid>
              <Grid item xs={12}>
                  <Typography variant="caption">
                      <FormattedMessage id="orders-product" />
                  </Typography>
                  <Typography variant="h6">
                      <a href={`/${order?.product?.category?.parent?.urlPrefix}`} style={{textDecoration: 'none', color: '#fff'}}>
                          <FontAwesomeIcon icon={order?.product?.category?.parent?.icon.split('-')} /> {order?.product?.category?.parent?.categoryMeta?.uk?.name?.replace(/<[^>]*>?/gm, '') ?? ''}
                      </a>
                      {' -> '}
                      <a href={`/${order?.product?.category?.parent?.urlPrefix}/${order?.product?.category?.urlPrefix}`} style={{textDecoration: 'none', color: '#fff'}}>
                        <FontAwesomeIcon icon={order?.product?.category?.icon.split('-')} /> {order?.product?.category?.categoryMeta?.uk?.name?.replace(/<[^>]*>?/gm, '') ?? ''}
                      </a>
                      {' -> '}
                      {order?.product?.productMeta?.uk?.name ?? ''}
                      <HtmlTooltip
                        title={
                            <React.Fragment>
                                <div>
                                    <FontAwesomeIcon icon={['fas', 'battery-quarter']} style={{paddingRight: 10}}/>
                                    <FormattedMessage id="form-min-order" /> <FormattedMessage id="categories-price-prefix" /> {order?.product?.min} <FormattedMessage id="pcs-select" />.
                                </div>

                                <div>
                                    <FontAwesomeIcon icon={['fas', 'play']} style={{paddingRight: 10}}/>
                                    <FormattedMessage id="form-start" /> {order?.product?.start} <FormattedMessage id="form-min" />
                                </div>

                                <div>
                                    <Divider style={{margin: '15px 0'}}/>
                                    <div dangerouslySetInnerHTML={{__html: order?.product?.productMeta?.uk?.description?.replace(/style=".*?"/ig,'')}} />
                                </div>
                            </React.Fragment>
                        }
                        enterTouchDelay={0}
                        leaveTouchDelay={120000}
                      >
                          <FontAwesomeIcon icon={faCircleInfo} style={{paddingLeft: 5}}/>
                      </HtmlTooltip>
                  </Typography>
              </Grid>
              <Grid item xs={12}>
                  <Typography variant="caption">
                      <FormattedMessage id="orders-pcs" />
                  </Typography>
                  <Typography variant="h6">{order.pcs}</Typography>
              </Grid>
              <Grid item xs={12}>
                  <Typography variant="caption">
                      <FormattedMessage id="orders-link" />
                  </Typography>
                  <Typography variant="h6">
                      <MuiTypography
                        variant="body2"
                        color="primary"
                        component={Link}
                        href={order.url}
                        target="_blank"
                        display="block"
                        gutterBottom
                      >
                          {order.url}
                      </MuiTypography>
                  </Typography>
              </Grid>
          </Grid>

          { (itemsLength > itemCount + 1) && <Divider style={{paddingTop: 15}}/> }
      </Grid>
    )
}

const OrdersDetailsCard = ({ products, rowsHorizontal }) => {
    return (
      <Card style={(rowsHorizontal && rowsHorizontal === 1) ? {backgroundColor: '#151b3100'} : {}}>
          <Grid container spacing={1}>
              {products && products.map((order, index) => <OrderOne
                order={order}
                rowsHorizontal={rowsHorizontal}
                itemCount={index}
                itemsLength={products.length}
              />)}
          </Grid>


          <Button variant="contained" href={
              `/${products[0]?.product?.category?.parent?.urlPrefix}/${products[0]?.product?.category?.urlPrefix}?product=${products[0]?.product?._id}`
          } style={{margin: '5px 0px'}}>
              <FormattedMessage id="form-btn-submit" />
          </Button>
      </Card>
    );
};

OrdersDetailsCard.propTypes = {
    orderId: PropTypes.string,
    status: PropTypes.string,
    pcs: PropTypes.string,
    link: PropTypes.string,
    productName: PropTypes.string,
};

export default OrdersDetailsCard;
